import { useContext, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import useRootSnackbar from '../services/useRootSnackbar'
import { UserContext, UserContextType } from '../UserContext'
import { AnalyticsEvents } from '../services/AnalyticsService'
import useAnalytics from '../services/useAnalytics'

export default function useLogout() {
    const { state, dispatch } = useContext(UserContext) as UserContextType

    const RootSnackbar = useRootSnackbar()
    const history = useHistory()
    const { logUserActivityWithContext } = useAnalytics()

    const logout = useCallback(() => {
        localStorage.removeItem('userCache')

        const username = state.profile?.username || null
        const isGuest = state.isGuest

        dispatch({ type: 'logout' })
        history.push('/')

        let logoutMessage = 'Logged out successfully.'
        if (username) {
            if (isGuest) {
                logoutMessage = `Successfully logged out of guest account.`
            } else {
                logoutMessage = `Successfully logged out of ${username}.`
            }
        }

        RootSnackbar.show({
            message: logoutMessage,
            severity: 'info',
        })

        logUserActivityWithContext(AnalyticsEvents.USER_LOGGED_OUT)
    }, [state.profile])

    return { logout }
}
